module.exports = __webpack_public_path__ + "img/grow_3.3ba25bc4.png";